import { createContext } from "react";

export const LanguageContext = createContext({
  // can set state values
  language: localStorage.getItem("lan") || "",
  setLanguage: () => {},
  createLanguage: () => {},
});
